import ImageWithFallback from 'components/ImageWithFallback';
import { referralsFolder } from 'constants/Referrals';
import type { ReactNode } from 'react';
import styles from './WhiteSpeechBubble.module.css';

type TailPosition = 'left-corner' | 'left-bottom';

interface WhiteSpeechBubbleProps {
  empty?: boolean;
  tailPosition?: TailPosition;
  children?: ReactNode;
}

export const WhiteSpeechBubble = ({
  empty,
  tailPosition = 'left-bottom',
  children,
}: WhiteSpeechBubbleProps) => {
  const tailClassName =
    tailPosition === 'left-corner'
      ? styles.tailLeftCorner
      : styles.tailLeftBottom;
  const rootClassName = empty ? `${styles.root} ${styles.empty}` : styles.root;

  return (
    <div className={rootClassName}>
      <div className={styles.body}>{children}</div>
      <div className={`${styles.tail} ${tailClassName}`}>
        <ImageWithFallback
          layout="fill"
          src={`${referralsFolder}/white-speech-bubble-tail.svg`}
        />
      </div>
    </div>
  );
};
